__turbopack_context__.v({
  "body": "Landing-module-scss-module__sMfBeq__body",
  "fade-in": "Landing-module-scss-module__sMfBeq__fade-in",
  "flushBottom": "Landing-module-scss-module__sMfBeq__flushBottom",
  "fullWidth": "Landing-module-scss-module__sMfBeq__fullWidth",
  "gridCard": "Landing-module-scss-module__sMfBeq__gridCard",
  "heading": "Landing-module-scss-module__sMfBeq__heading",
  "hero": "Landing-module-scss-module__sMfBeq__hero",
  "heroInner": "Landing-module-scss-module__sMfBeq__heroInner",
  "image": "Landing-module-scss-module__sMfBeq__image",
  "imageWrapper": "Landing-module-scss-module__sMfBeq__imageWrapper",
  "isRounded": "Landing-module-scss-module__sMfBeq__isRounded",
  "landscape": "Landing-module-scss-module__sMfBeq__landscape",
  "productGrid": "Landing-module-scss-module__sMfBeq__productGrid",
  "productGridFlex": "Landing-module-scss-module__sMfBeq__productGridFlex",
  "subTitle": "Landing-module-scss-module__sMfBeq__subTitle",
  "title": "Landing-module-scss-module__sMfBeq__title",
});
